var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "workers-list",
      class: {
        "workers-list--shifting": _vm.shifting,
      },
    },
    [
      _vm.loadingBack
        ? _c("Loader", {
            attrs: {
              active: _vm.loadingBack,
              height: "fixed",
              label: "Загрузка сотрудников",
            },
          })
        : _vm._e(),
      _vm.loadingBack
        ? _c("div", { staticClass: "workers-list-message" }, [
            _c("div", {
              staticClass: "workers-list-message__panel workers-list__loader",
            }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "workers-list-shifting-container" }, [
        _c(
          "div",
          { staticClass: "workers-list__loader" },
          [
            _c("Loader", {
              attrs: { active: true, label: "Загрузка периодов" },
            }),
          ],
          1
        ),
      ]),
      _c(
        "position-watcher",
        {
          ref: "positionWatcher",
          staticClass: "workers-list__items",
          on: { bottomInView: _vm.nextPage, topInView: _vm.prevPage },
          model: {
            value: _vm.position,
            callback: function ($$v) {
              _vm.position = $$v
            },
            expression: "position",
          },
        },
        _vm._l(_vm.workersToRender, function (w) {
          return _c("WorkerRow", {
            key: w.id,
            attrs: {
              days: _vm.days,
              worker: w,
              "can-edit": _vm.canEdit,
              "show-all": _vm.showAll,
              "data-worker": w.id,
            },
          })
        }),
        1
      ),
      _vm.inited &&
      !_vm.loadingForward &&
      !_vm.loadingBack &&
      _vm.empty &&
      _vm.lastRequestEmpty
        ? _c("div", { staticClass: "workers-list-message" }, [
            _c(
              "div",
              {
                staticClass: "workers-list-message__panel workers-list__empty",
              },
              [_vm._v(" За текущий период отпуска и больничные не найдены ")]
            ),
          ])
        : _vm._e(),
      _vm.loadingForward
        ? _c("div", { staticClass: "workers-list-message" }, [
            _c(
              "div",
              {
                staticClass: "workers-list-message__panel workers-list__loader",
              },
              [
                _c("Loader", {
                  attrs: {
                    active: true,
                    height: "fixed",
                    label: "Загрузка сотрудников",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }